import config from "../config/config";

const ICON_URLS = {
  logo: `${config.icons.logo}`,
};
const LOGO_ALT = config.common.mapionLogoAlt;

const MapLogo = () => (
  <div id="map-logo">
    <img
      src={ICON_URLS.logo}
      alt={LOGO_ALT}
    />
  </div>
);

export default MapLogo;